/* eslint-disable import/prefer-default-export */
import urlsV1 from '@api/v1/urls';

export const urls = Object.freeze({
  v1: urlsV1,
});
